<div class="card mt-3 mx-1 pb-3" style="width: 50vw; overflow: hidden">
  <mdb-accordion flush="true">
    <mdb-accordion-item>
      <ng-template mdbAccordionItemHeader>
        {{ "NAVIGATION.CROP" | translate }}
      </ng-template>
      <ng-template mdbAccordionItemBody>
        <div class="pb-2" style="height: 17rem; overflow-y: auto">
          <div class="row pt-2 mb-2 px-2 mx-2 sticky-top bg-white">
            <div class="col">
              {{ "NAVIGATION.MATERIAL_TYPE_CLASSIFICATION" | translate }}
            </div>
            <div class="bg-primary" style="height: 2px"></div>
          </div>
          <div
            class="row py-2 px-2 mx-4 rounded"
            *ngFor="let quality of crop; index as i"
            [ngClass]="i % 2 == 0 ? 'bg-white' : 'bg-light'"
          >
            <div class="col">{{ quality.typeLang }}</div>
          </div>
        </div>
      </ng-template>
    </mdb-accordion-item>

    <mdb-accordion-item>
      <ng-template mdbAccordionItemHeader>
        {{ "NAVIGATION.LIVESTOCK" | translate }}
      </ng-template>
      <ng-template mdbAccordionItemBody>
        <div class="pb-2" style="height: 17rem; overflow-y: auto">
          <div class="row pt-2 mb-2 px-2 mx-2 sticky-top bg-white">
            <div class="col">
              {{ "NAVIGATION.MATERIAL_TYPE_CLASSIFICATION" | translate }}
            </div>
            <div class="bg-primary" style="height: 2px"></div>
          </div>
          <div
            class="row py-2 px-2 mx-4 rounded"
            *ngFor="let quality of livestock; index as i"
            [ngClass]="i % 2 == 0 ? 'bg-white' : 'bg-light'"
          >
            <div class="col">{{ quality.typeLang }}</div>
          </div>
        </div>
      </ng-template>
    </mdb-accordion-item>

    <mdb-accordion-item>
      <ng-template mdbAccordionItemHeader>
        {{ "NAVIGATION.AQUACULTURE" | translate }}
      </ng-template>
      <ng-template mdbAccordionItemBody>
        <div class="pb-2" style="height: 17rem; overflow-y: auto">
          <div class="row pt-2 mb-2 px-2 mx-2 sticky-top bg-white">
            <div class="col">
              {{ "NAVIGATION.MATERIAL_TYPE_CLASSIFICATION" | translate }}
            </div>
            <div class="bg-primary" style="height: 2px"></div>
          </div>
          <div
            class="row py-2 px-2 mx-4 rounded"
            *ngFor="let quality of aquaculture; index as i"
            [ngClass]="i % 2 == 0 ? 'bg-white' : 'bg-light'"
          >
            <div class="col">{{ quality.typeLang }}</div>
          </div>
        </div>
      </ng-template>
    </mdb-accordion-item>
  </mdb-accordion>
</div>
